const Collections = {
  parts: [
    'container',
    'containerInner',
    'headerSection',
    'title',
    'description',
    'collectionsList',
    'collectionItem',
    'collectionImageContainer',
    'collectionImage',
    'collectionOverlay',
    'collectionLabel'
  ],
  baseStyle: {
    container: {
      bg: 'brandColors.secondaryBG', // Linen background from design
    },
    containerInner: {
      maxWidth: '1440px',
      mx: 'auto',
      display: 'flex',
      py: {base: 14, md: 30}, // 56px mobile top, 120px desktop
      pb: {base: 20, md: 30}, // 80px mobile bottom, 120px desktop
      px: {base: 0, md: 0}, // 20px mobile, 80px desktop
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 10, md: 18.5}, // 40px mobile, 74px desktop
      alignSelf: 'stretch',
    },
    headerSection: {
      display: 'flex',
      px: {base: 5, md: 20}, // 0 mobile (already padded by container), 80px desktop
      width: 'full', // Fixed width from design
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexDirection: {base: 'column', md: 'row'},
      gap: {base: 4, md: 0}, // 16px mobile gap
    },
    title: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
      fontFamily: 'heading',
      fontSize: {base: '28px', md: '40px'}, // 28px mobile, 40px desktop
      fontWeight: 'medium', // 500
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', md: '-0.4px'},
      flex: {base: 'none', md: '1 0 0'},
      mb: 0,
    },
    description: {
      display: 'flex',
      width: {base: 'full', md: '620px'}, // Fixed width from design
      minWidth: {base: 'auto', md: '620px'},
      pt: {base: 0, md: 2}, // 8px desktop
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: 6, // 24px
      flex: {base: 'none', md: '1 0 0'},
      flexShrink: 0,
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: 'md', md: 'lg'}, // 16px mobile, 18px desktop
      fontWeight: 'normal',
      lineHeight: '160%',
    },
    collectionsList: {
      display: 'flex',
      pl: {base: 5, md: 20}, // 0 mobile (already padded by container), 80px desktop
      alignItems: 'center',
      gap: 1, // 4px from design
      alignSelf: 'stretch',
      position: 'relative',
      overflow: 'hidden',
      sx: {
        '.swiper': {
          overflow: 'visible',
          width: 'full',
        },
        ' .swiper-slide': {
          width: 'auto',
        },

        '.swiper-button-next, .swiper-button-prev': {
          display: {base: 'none', md: 'flex'},
          width: {base: 15, md: 17.5}, // 70px from design
          height: {base: 15, md: 17.5}, // 70px from design
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2.5, // 10px
          aspectRatio: '1/1',
          borderRadius: 'full', // Large border radius for circular
          bg: 'brandColors.greyscale20', // 20% opacity from design
          backdropFilter: 'blur(15px)',
          cursor: 'pointer',
          pointerEvents: 'auto',
          transition: 'all 0.2s ease',
          _hover: {
            bg: 'brandColors.greyscale30',
          },
          _disabled: {
            opacity: 0.5,
            cursor: 'default',
          },
        },
        '.swiper-button-disabled': {
          opacity: 0.5,
          cursor: 'default',
        },
        '.swiper-button-next::after, .swiper-button-prev::after': {
          display: 'none',
        },
        '.swiper-button-next::before, .swiper-button-prev::before': {
          content: '" "',
          display: 'block',
          width: '100%',
          height: '100%',
          backgroundColor: 'transparent',
          backgroundSize: '12px 12px',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        },
        '.swiper-button-next': {
          right: 10,
        },
        '.swiper-button-next::before': {

          backgroundImage: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2214%22%20viewBox%3D%220%200%2012%2014%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M3.87485%2012.625L9.23485%207.265C9.26968%207.23022%209.29731%207.18891%209.31617%207.14344C9.33502%207.09797%209.34473%207.04922%209.34473%207C9.34473%206.95078%209.33502%206.90203%209.31617%206.85656C9.29731%206.81109%209.26968%206.76978%209.23485%206.735L3.87485%201.375%22%20stroke%3D%22white%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E',
        },
        '.swiper-button-prev': {
          left: '-38px',
        },
        '.swiper-button-prev::before': {
          backgroundImage: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2214%22%20viewBox%3D%220%200%2012%2014%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M8.12515%2012.625L2.76515%207.265C2.73032%207.23022%202.70269%207.18891%202.68383%207.14344C2.66498%207.09797%202.65527%207.04922%202.65527%207C2.65527%206.95078%202.66498%206.90203%202.68383%206.85656C2.70269%206.81109%202.73032%206.76978%202.76515%206.735L8.12515%201.375%22%20stroke%3D%22white%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E',
        },
      },
    },
    collectionItem: {
      display: 'flex',
      width: {base: '146px', md: '240px'}, // 146px mobile, 240px desktop
      height: {base: '200px', md: 'auto'}, // Fixed height for mobile
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 2, // 8px
      flexShrink: 0,
      aspectRatio: {base: '73/100', md: 'auto'}, // 146/200 ratio for mobile
    },
    collectionImageContainer: {
      width: 'full', // Exact width from mobile design
      height: {base: '200px', md: '316px'}, // 200px mobile, 316px desktop
      flex: {base: '1 0 0', md: 'none'},
      alignSelf: 'stretch',
      position: 'relative',
      overflow: 'hidden',
      aspectRatio: {base: '145.57/200', md: 'auto'},
    },
    collectionImage: {
      width: 'full',
      height: {base: '200px', md: 'full'},
      objectFit: 'cover',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    collectionOverlay: {
      width: 'full',
      height: 'ato', // 112px for both mobile and desktop
      flexShrink: 0,
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 100%)',
      position: 'absolute',
      left: 0,
      top: {base: '88px', md: 'auto'}, // 88px from top on mobile
      bottom: 0, // Bottom positioned on desktop
      display: 'flex',
      alignItems: 'flex-end',
      p: {base: '14px', md: '22px 19px'}, // 14px mobile, 19px desktop
    },
    collectionLabel: {
      width: {base: '120px', md: 'auto'}, // Fixed width on mobile
      color: 'rgba(255, 255, 255, 0.90)', // White 90% from design
      fontFamily: 'heading',
      fontSize: {base: 'md', md: 'xl'}, // 16px mobile, 20px desktop
      fontWeight: 'medium', // 500
      lineHeight: '120%',
      height: {base: '19px', md: 'auto'}, // Fixed height on mobile
      mb: 0,
    },
  },
};

export default Collections;
